module.exports = __webpack_public_path__ + "static/img/certificate01.d78f0111.jpeg";